import { Dispatch } from "react";
import { CleaningRouteList } from "./state";
import {
    CleaningRouteAction,
    changeCleaningDetailRouteAction,
    changeCleaningRouteNameAction,
    handlCleaningRouteRemarksChangeAction,
    handlCleaningRouteWeekdayChange,
    handlClearCleaningRouteAction,
    handleCleanerChangeAction,
    handleCleaningRouteEndTimeAction,
    handleCleaningRouteStartTimeAction,
    handleEffectiveDateChangeAction,
    initCleaningRouteListAction,
    initSelectedCleaningRouteDetailAction,
    setHolidayAction,
    setWeekdayFlagsAction,
} from "./action";
import { MultiValue } from "react-select";
import { BinInfo } from "../staticInfo/state";

export function initCleaningRouteListThunk(
    cleaningRouteList: CleaningRouteList[]
) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(initCleaningRouteListAction(cleaningRouteList));
    };
}

export function initCleaningDetailRouteThunk(
    selectedDetailRouteList: MultiValue<BinInfo>,
    cleaningRoute: CleaningRouteList
) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(
            initSelectedCleaningRouteDetailAction(
                selectedDetailRouteList,
                cleaningRoute
            )
        );
    };
}

export function changeCleaningDetailRouteThunk(
    selectedDetailRouteList: MultiValue<BinInfo>
) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(changeCleaningDetailRouteAction(selectedDetailRouteList));
    };
}

export function handleDropDownCleaningRouteThunk(
    draggedIndex: number,
    selectedBinInfo: MultiValue<BinInfo>,
    index: number
) {
    const newSelectedBinInfo = Array.from(selectedBinInfo!);
    const [removed] = newSelectedBinInfo.splice(draggedIndex, 1);
    newSelectedBinInfo.splice(index, 0, removed);
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(changeCleaningDetailRouteAction(newSelectedBinInfo));
    };
}

export function handleCleaningRouteNameChangeThunk(route_name: string) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(changeCleaningRouteNameAction(route_name));
    };
}

export function handleEffectiveDateChangeThunk(effective_date: Date) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(handleEffectiveDateChangeAction(effective_date));
    };
}

export function handleCleanerChangeThunk(cleaner_id: string) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(handleCleanerChangeAction(cleaner_id));
    };
}

export function handleRouteCleaningWeekdayChangeThunk(weekday: string) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(handlCleaningRouteWeekdayChange(weekday));
    };
}

export function setWeekdayFlagsThunk(payload: {
    mon?: number;
    tue?: number;
    wed?: number;
    thu?: number;
    fri?: number;
    sat?: number;
    sun?: number;
}) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(setWeekdayFlagsAction(payload));
    };
}

export function setHolidayThunk(holiday: number) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(setHolidayAction(holiday));
    };
}

export function handleRouteCleaningRemarksChangeThunk(remarks: string) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(handlCleaningRouteRemarksChangeAction(remarks));
    };
}

export function handleStartTimeChangeThunk(time_start: string, index: number) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(handleCleaningRouteStartTimeAction(time_start, index));
    };
}

export function handleEndTimeChangeThunk(time_end: string, index: number) {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(handleCleaningRouteEndTimeAction(time_end, index));
    };
}

export function handleClearCleaningRouteListThunk() {
    return (dispatch: Dispatch<CleaningRouteAction>) => {
        dispatch(handlClearCleaningRouteAction());
    };
}